import resetHooks from "./reset-hooks";

/**
 * Set (reset) alternate timeline data
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 * @param {Array<StepProps>} steps
 * @param {Boolean} enter
 * @param {Number} iteration
 */
const setAlternateData = (trigger, timeline, steps, enter, iteration) => {
  const percents = enter ? 1 : 0;

  trigger.set("enter", !enter);
  timeline.set("leave-time", null);
  timeline.set("enter-time", null);
  timeline.set("is-alternating", enter);

  for (const step of steps.values()) {
    step.set("switch-percents", percents);
  }

  if (!enter) {
    timeline.set("current-iteration", ++iteration);
  }

  resetHooks(steps);
};

export default setAlternateData;
